var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArSlot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7648",
    "data-name": "Group 7648",
    transform: "translate(12788 -10210)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_22129",
    "data-name": "Ellipse 22129",
    transform: "translate(-12788 10210)",
    fill: "#fff",
    stroke: "#4f5b6d",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "ic_place_24px",
    d: "M8.61,2A3.607,3.607,0,0,0,5,5.61c0,2.707,3.61,6.7,3.61,6.7s3.61-4,3.61-6.7A3.607,3.607,0,0,0,8.61,2Zm0,4.9A1.289,1.289,0,1,1,9.9,5.61,1.29,1.29,0,0,1,8.61,6.9Z",
    transform: "translate(-12788.682 10210.969)",
    fill: "#4f5b6d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArSlot);
export default __webpack_public_path__ + "static/media/ar-slot.0a962f9d8ead020cd5815a66845f2f32.svg";
export { ForwardRef as ReactComponent };